import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-homecontainer',
  templateUrl: './homecontainer.component.html',
  styleUrls: ['./homecontainer.component.css']
})
export class HomecontainerComponent implements OnInit {

  constructor(public authService : AuthService) { }

  hvacContractor = false;


  ngOnInit(): void {

    this.authService.getUser$().subscribe(
      (res) => {
        console.log(res);
        this.hvacContractor = (this.authService.role == 'HVACUser');
        console.log('iS HVAC contractor: ' +  this.hvacContractor);

      }, err => {
        console.log(err);
      }
    )

  }

}
